import useTranslation from "@/hooks/useTranslation";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Typography } from "antd";

const { Title, Paragraph } = Typography;

const NaviIntroduction: React.FC = () => {
  const { t } = useTranslation("explore");
  const rows: {
    name: string;
    syntax: string;
    fields: string;
    example: string;
  }[] = [
    {
      name: t("navi.syntax.author"),
      syntax: "`<target>`{author}",
      fields: "author *(use space between first and last name)",
      example: "`John Doe`{author}",
    },
    {
      name: t("navi.syntax.location"),
      syntax: "`<target>`{location}",
      fields: "location *(use full name of location)",
      example: "`United States`{location}",
    },
    {
      name: t("navi.syntax.journal"),
      syntax: "`<target>`{<field>}",
      fields: "journal *(use medline Abbr of journal)",
      example: "`Nat. Methods`{journal}",
    },
    {
      name: t("navi.syntax.keyword"),
      syntax: "`<target>`{<field>}",
      fields: "title, affiliations, keywords, abstract, journals, all",
      example: "`single cell`{title}",
    },
  ];

  return (
    <Typography>
      <Title level={2}>{t("navi.syntax.itself")}</Title>
      <Paragraph>
        <TableContainer component={Paper} elevation={0}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">{t("navi.syntax.name")}</TableCell>
                <TableCell align="center">{t("navi.syntax.syntax")}</TableCell>
                <TableCell align="center">{t("navi.syntax.fields")}</TableCell>
                <TableCell align="center">{t("navi.syntax.example")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.name}>
                  <TableCell component="th" scope="row" align="center">
                    {row.name}
                  </TableCell>
                  <TableCell align="center">{row.syntax}</TableCell>
                  <TableCell align="center">{row.fields}</TableCell>
                  <TableCell align="center">{row.example}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paragraph>
    </Typography>
  );
};

export default NaviIntroduction;
